import React from 'react'
import imageLogo from './../images/image-logo.png'
import { Link } from 'react-router-dom'

const Footer = (): JSX.Element => {
  return (
    <div className="bg-king-blue text-white p-[30px] grid grid-cols-1 gap-5 max-w-[1200px] w-full mx-auto font-extralight md:py-10 md:px-[60px] md:grid-cols-[min-content_auto_min(190px)]">
      <div className="flex flex-col justify-center">
        <div>
          <Link
            to="https://kingenergy.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={imageLogo}
              alt=""
              className="w-[160px] max-w-[160px] mr-10"
            />
          </Link>
        </div>
      </div>
      <div className="flex flex-col justify-center [&_a]:text-white [&_a]:whitespace-nowrap [&_p]:mb-5 [&_p:last-of-type]:mb-0 md:[&_p]:text-base md:[&_a]:text-base md:[&_p]:inline md:[&_a]:inline">
        <div className="text-xl mb-[5px] md:text-xl">Questions?</div>
        <p>
          Please{' '}
          <Link to="/docs/faq.pdf" target="_blank" rel="noopener noreferrer" className="underline text-white hover:text-white">
            read our FAQs
          </Link>
          ,<br />
          give us a call at <Link to="tel:8007811765" className="underline text-white hover:text-white">(800) 781-1765</Link>,<br />
          or email us at{' '}
          <Link to="mailto:support@kingenergy.com" className="underline text-white hover:text-white">support@kingenergy.com</Link>.
        </p>
      </div>
      <div className="flex flex-col justify-end">
        <div>
          <div>
            © {new Date().getFullYear()} King Energy, Inc. All rights reserved.
          </div>
          <Link
            to="https://www.kingenergy.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-white hover:text-white"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Footer
